export default __webpack_public_path__ + "static/media/Falkonry.90da35fb.png";